import React from "react";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";

const PUBLIC_URL = process.env.PUBLIC_URL || "";
const WHO_WE_ARE_HERO_IMG = `${PUBLIC_URL}/${encodeURIComponent(
  "image 74.jpg",
)}`;
const FOUNDER_PHOTO = `${PUBLIC_URL}/${encodeURIComponent("Ellipse 4836.png")}`;

export const CustomBeautyTitle = ({ title }: { title: string }) => {
  return <h2 className="custom-esb-title">{title}</h2>;
};

const TeamCard = ({
  photo,
  name,
  role,
}: {
  photo?: string;
  name: string;
  role: string;
}) => {
  return (
    <div className="team-card">
      <span className="photo-wrapper">
        <img loading="lazy" src={photo} alt="photo" />
      </span>
      <span className="name">{name}</span>
      <span className="role">{role}</span>
    </div>
  );
};

function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page">
        <h1 className="custom-page-title">Qui sommes-nous ?</h1>
        <div className="who-we-are">
          <div className="container">
            <div className="row who-we-are-hero align-items-start g-4 g-lg-4">
              <div className="col-lg-6 mb-4 mb-lg-0 who-we-are-hero__visual">
                <figure className="who-we-are-hero__figure">
                  <img
                    src={WHO_WE_ARE_HERO_IMG}
                    alt="Kazamansa — Inspiration et innovation, téléphone (+221) 77 716 56 56, info et commande"
                    loading="lazy"
                  />
                </figure>
              </div>
              <div className="col-lg-6 who-we-are-hero__copy">
                <h2 className="who-we-are-hero__brand">KAZAMANSA</h2>

                {/* Bloc 1 : présentation */}
                <p className="who-we-are-hero__body">
                  Découvrez <strong>KAZAMANSA</strong>, la nouvelle signature du carrelage d&apos;exception
                </p>
                <p className="who-we-are-hero__body who-we-are-hero__body--gap">
                  Ce qui définit notre carrelage : tradimoderne, design et contemporain.
                </p>

                {/* Bloc 2 : mission */}
                <h3 className="who-we-are-hero__subhead">Notre mission</h3>
                <p className="who-we-are-hero__body">
                  Rendre l&apos;extraordinaire accessible à tous.
                </p>
                <p className="who-we-are-hero__body who-we-are-hero__body--gap">
                  Pourquoi choisir <strong>KAZAMANSA</strong> ?
                </p>

                {/* Bloc 3 : différenciateurs */}
                <p className="who-we-are-hero__body">
                  <strong>Inédit :</strong> Des designs originaux et créatifs que vous ne verrez nulle part ailleurs.
                </p>
                <p className="who-we-are-hero__body">
                  <strong>Excellence :</strong> Une qualité supérieure pour un intérieur qui dure.
                </p>
                <p className="who-we-are-hero__body who-we-are-hero__body--gap">
                  <strong>Accessibilité :</strong> Parce que le luxe ne devrait pas être un privilège, nous réinventons votre façon d&apos;acheter.
                </p>

                {/* Bloc 4 : paiement */}
                <p className="who-we-are-hero__body">
                  Vous pouvez anticiper et épargner pour votre projet ! Grâce à nos facilités de paiement, offrez-vous le carrelage de vos rêves dès le début du gros-œuvre ou pour votre rénovation.
                </p>
                <p className="who-we-are-hero__body who-we-are-hero__body--gap">
                  Payez en plusieurs fois et transformez votre espace sans compromis.
                </p>

                {/* Closing */}
                <p className="who-we-are-hero__closing">
                  Osez l&apos;originalité. Osez <strong>KAZAMANSA</strong>.
                </p>
              </div>
            </div>
            <section
              className="items mt-5 who-we-are-values"
              aria-labelledby="who-we-are-values-heading"
            >
              <h2
                id="who-we-are-values-heading"
                className="who-we-are-values__title"
              >
                Nos valeurs
              </h2>

              <h3 className="who-we-are-values__subhead who-we-are-values__subhead--first">
                L&apos;art sacré s&apos;invite chez vous
              </h3>
              <p className="who-we-are-values__body">
                <strong>KAZAMANSA</strong> a également une vision audacieuse en
                se spécialisant dans le revêtement de prestige, avec un
                savoir-faire unique au Sénégal dédié au{" "}
                <strong>carrelage religieux et sacré</strong>.
              </p>

              <h3 className="who-we-are-values__subhead">
                L&apos;exception au cœur de votre foyer
              </h3>
              <p className="who-we-are-values__body who-we-are-values__body--tight-below">
                Nous avons choisi de briser les conventions. Les fresques
                religieuses, les représentations d&apos;icônes et les dalles
                tombales travaillées ne sont plus l&apos;exclusivité des lieux de
                culte.
              </p>
              <p className="who-we-are-values__body">
                Chez <strong>KAZAMANSA</strong>, nous permettons à chaque
                particulier d&apos;intégrer ces{" "}
                <strong>pièces rares et spirituelles</strong> au sein de son
                propre habitat.
              </p>

              <p className="who-we-are-values__tagline">
                Nos maîtres-mots : Originalité | Spiritualité | Qualité |
                Accessibilité
              </p>

              <p className="who-we-are-values__body who-we-are-values__intro">
                Parce que l&apos;excellence ne doit pas être un luxe inatteignable,
                nous avons réinventé l&apos;expérience d&apos;achat :
              </p>
              <ul className="who-we-are-values__list">
                <li>
                  <strong>Des œuvres inédites :</strong> Des fresques et
                  carreaux que vous ne verrez nulle part ailleurs
                </li>
                <li>
                  <strong>Paiement flexible :</strong> Épargnez à votre rythme et
                  profitez de nos solutions de paiement échelonné.
                </li>
                <li>
                  <strong>Inspiration et Innovation :</strong> avec{" "}
                  <strong>KAZAMANSA</strong>, offrez à votre foyer une dimension
                  sacrée et une signature esthétique hors du commun.
                </li>
              </ul>
            </section>

            <section className="items mt-5 founder-message" aria-labelledby="founder-word-title">
              <div className="founder-message__content">
                <div className="founder-message__card">
                  <img
                    src={FOUNDER_PHOTO}
                    alt="Marie-Hélène SAGNA"
                    loading="lazy"
                    className="founder-message__avatar"
                  />
                  <p className="founder-message__card-name">Marie-Hélène SAGNA</p>
                  <p className="founder-message__card-role">Fondatrice et gérante</p>
                </div>

                <div className="founder-message__line" />
                <h2 id="founder-word-title" className="founder-message__title">
                  Mot de la fondatrice
                </h2>
                <p className="founder-message__quote">
                  "Parce que votre foyer mérite l&apos;exception"
                </p>

                <p className="founder-message__body">
                  Chez <strong>KAZAMANSA</strong>, nous croyons que le beau et le
                  solide ne devraient pas être un luxe réservé à quelques-uns.
                  J&apos;ai créé cette entreprise avec une mission simple : mettre
                  l&apos;art du carrelage à votre portée.
                </p>
                <p className="founder-message__body">
                  Notre slogan, <strong>Inspiration &amp; Innovation</strong>,
                  définit tout ce que nous faisons. Nous avons choisi de casser les
                  codes pour vous offrir des pièces rares, originales et de haute
                  qualité, tout en respectant votre budget.
                </p>

                <p className="founder-message__body">
                  <strong>Pourquoi nous choisir ?</strong>
                  <br />
                  <strong>L&apos;exclusivité :</strong> Des styles que vous ne
                  verrez nulle part ailleurs.
                </p>
                <p className="founder-message__body">
                  <strong>La flexibilité :</strong> Nous vous accompagnons avec le
                  paiement échelonné.
                  <br />
                  Épargnez à votre rythme, que vous soyez en plein gros-œuvre ou
                  en rénovation.
                </p>

                <p className="founder-message__body">
                  Mon engagement est de vous offrir l&apos;excellence sans le
                  stress financier. Ensemble, faisons de votre maison un lieu
                  unique qui vous ressemble.
                </p>

                <p className="founder-message__signature-name">Marie-Hélène SAGNA</p>
                <p className="founder-message__signature-role">
                  Fondatrice de KAZAMANSA
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
